module.exports = __webpack_public_path__ + "img/run-back.f76fe553.png";